let config = {
  // Staging
  AppsAPIURL: "https://apps-api.jewelcloud.com/api",
  AdminAPIURL: "https://admin-api.jewelcloud.com/api",
  DealerAPIURL: "https://dealer-api.jewelcloud.com/api",

  // MGR
  // AdminAPIURL: "https://jc2-admin-api.mgr.brainvire.net/api",
  // AppsAPIURL: "https://jc2-apps-api.mgr.brainvire.net/api",
  // DealerAPIURL: "https://jc2-dlr-api.mgr.jewelcloud.com/api",
};

export default config;
